import { useEffect, useState } from 'react';
import client from '../api/client';

const n = v => Number(v || 0);
const fmtLag = s => {
  s = Number(s || 0);
  if (s < 3600) return Math.round(s/60) + 'm';
  const h = Math.floor(s/3600), m = Math.round((s%3600)/60);
  return h + 'h ' + m + 'm';
};
const fmtPhone = p => {
  if (!p) return null;
  const d = String(p).replace(/\D/g,'');
  return d.length === 10 ? '(' + d.slice(0,3) + ') ' + d.slice(3,6) + '-' + d.slice(6) : p;
};

const Stat = ({ label, value, color, onClick, active }) => (
  <div onClick={onClick} style={{ background: active ? '#eef3ff' : '#f7f7f7', borderRadius:10, padding:'10px 12px',
    minWidth:0, cursor: onClick ? 'pointer' : 'default',
    border: '2px solid ' + (active ? '#1a5cff' : 'transparent') }}>
    <div style={{ fontSize:11, color:'#666' }}>{label}</div>
    <div style={{ fontSize:20, fontWeight:700, color:color||'#111' }}>{value}</div>
  </div>
);

export default function EngagementLeads() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pick, setPick] = useState(null);
  const [copied, setCopied] = useState(null);
  const [view, setView] = useState('engaged');

  const load = (cid) => {
    setLoading(true);
    const q = cid ? '?campaignId=' + cid : '';
    client.get('/admin/marketing/engagement-leads' + q)
      .then(r => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  };
  useEffect(() => { load(null); }, []);

  const camps = data?.campaigns || [];
  const all = data?.leads || [];
  const leads = all.filter(l => {
    if (view === 'engaged')  return l.activated_at && !l.unsubscribed_at;
    if (view === 'signed')   return !!l.mkt_signed_up_at;
    if (view === 'unsub')    return !!l.unsubscribed_at;
    return true;
  });
  const tot = camps.reduce((a,c) => ({
    delivered: a.delivered + n(c.delivered), engaged: a.engaged + n(c.engaged),
    signed: a.signed + n(c.signed_up), unsub: a.unsub + n(c.unsubscribed),
    noise: a.noise + n(c.scanner_noise)
  }), { delivered:0, engaged:0, signed:0, unsub:0, noise:0 });

  const copy = (t, id) => { navigator.clipboard?.writeText(t); setCopied(id); setTimeout(()=>setCopied(null), 1500); };

  return (
    <div>
      <h1 style={{ fontSize:20, fontWeight:700, margin:'0 0 4px', color:'#111' }}>Engagement leads</h1>
      <p style={{ color:'#666', margin:'0 0 18px', fontSize:14 }}>
        Contacts who verified through a campaign link and have not unsubscribed. Mail-scanner fetches are excluded.
      </p>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(110px,1fr))', gap:8, marginBottom:18 }}>
        <Stat label="Delivered" value={tot.delivered} />
        <Stat label="Engaged" value={tot.engaged} color="#0a8a40" onClick={()=>setView('engaged')} active={view==='engaged'} />
        <Stat label="Signed up" value={tot.signed} onClick={()=>setView('signed')} active={view==='signed'} />
        <Stat label="Unsubscribed" value={tot.unsub} color="#a32d2d" onClick={()=>setView('unsub')} active={view==='unsub'} />
        <Stat label="Scanner noise" value={tot.noise} color="#999" />
      </div>

      <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:14 }}>
        <button onClick={() => { setPick(null); load(null); }}
          style={{ fontSize:13, padding:'6px 12px', borderRadius:8, cursor:'pointer',
            border:'1px solid ' + (pick===null?'#1a5cff':'#e2e2e2'), background: pick===null?'#eef3ff':'#fff', color: pick===null?'#1a5cff':'#555' }}>
          All campaigns
        </button>
        {camps.map(c => (
          <button key={c.id} onClick={() => { setPick(c.id); load(c.id); }}
            style={{ fontSize:13, padding:'6px 12px', borderRadius:8, cursor:'pointer',
              border:'1px solid ' + (pick===c.id?'#1a5cff':'#e2e2e2'), background: pick===c.id?'#eef3ff':'#fff', color: pick===c.id?'#1a5cff':'#555' }}>
            {c.name} &nbsp;{n(c.engaged)}
          </button>
        ))}
      </div>

      {camps.map(c => (
        <div key={c.id} style={{ border:'1px solid #eee', borderRadius:10, padding:'10px 12px', marginBottom:8,
          display:'flex', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
          <div>
            <div style={{ fontSize:14, color:'#111' }}>{c.name}</div>
            <div style={{ fontSize:11, color:'#999' }}>{c.segment} &middot; {c.status}</div>
          </div>
          <div style={{ fontSize:12, color:'#666', alignSelf:'center' }}>
            {n(c.delivered) || n(c.sent)} sent &middot; <span style={{ color:'#0a8a40' }}>{n(c.engaged)} engaged</span>
            &nbsp;&middot; {n(c.signed_up)} signed up &middot; <span style={{ color:'#a32d2d' }}>{n(c.unsubscribed)} unsub</span>
          </div>
        </div>
      ))}

      <div style={{ fontSize:12, color:'#777', margin:'18px 0 8px' }}>
        {loading ? 'Loading...' : 'Showing ' + leads.length + ' ' + (view==='signed'?'signed up':view==='unsub'?'unsubscribed':'engaged') + ', sorted by time to click'}
      </div>

      {!loading && leads.length === 0 && (
        <div style={{ border:'1px dashed #ddd', borderRadius:10, padding:24, textAlign:'center', color:'#888', fontSize:14 }}>
          No engaged leads yet for this selection.
        </div>
      )}

      {leads.map(l => (
        <div key={l.id + '-' + l.campaign_id} style={{ border:'1px solid #eee', borderRadius:10, padding:12, marginBottom:8,
          display:'flex', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
          <div style={{ minWidth:0 }}>
            <div style={{ fontSize:14, color:'#111' }}>
              {l.business_name || l.contact_name || l.email}
              <span style={{ fontSize:10, padding:'2px 8px', borderRadius:6, marginLeft:8,
                background: l.unsubscribed_at ? '#fdeaea' : '#e6f5ee', color: l.unsubscribed_at ? '#a32d2d' : '#0f6e56' }}>
                {l.unsubscribed_at ? 'UNSUBSCRIBED' : 'ENGAGED'}</span>
              {l.mkt_signed_up_at && <span style={{ fontSize:10, padding:'2px 8px', borderRadius:6, background:'#eef3ff', color:'#1a5cff', marginLeft:6 }}>SIGNED UP</span>}
            </div>
            <div style={{ fontSize:12, color:'#666', marginTop:2 }}>
              {l.contact_name ? l.contact_name + ' \u00b7 ' : ''}{fmtPhone(l.phone) || 'no phone'} &middot; {l.email}
            </div>
            <div style={{ fontSize:11, color:'#999', marginTop:2 }}>
              Clicked {fmtLag(l.lag_seconds)} after send &middot; {l.campaign_name}
              {!l.mkt_signed_up_at && ' \u00b7 no account'}
            </div>
          </div>
          <div style={{ display:'flex', gap:6, alignItems:'flex-start' }}>
            {l.phone && <a href={'tel:' + String(l.phone).replace(/\D/g,'')}
              style={{ fontSize:12, border:'1px solid #ddd', borderRadius:8, padding:'6px 10px', textDecoration:'none', color:'#1a5cff' }}>Call</a>}
            <button onClick={() => copy(l.email, l.id)}
              style={{ fontSize:12, border:'1px solid #ddd', borderRadius:8, padding:'6px 10px', cursor:'pointer', background:'#fff', color:'#555' }}>
              {copied === l.id ? 'Copied' : 'Copy email'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
